<template>
  <div class="subscribe flex center">
    <el-card style="width: 600px; height: 300px;" :body-style="bodyStyle" v-loading="loading">
      <div class="logo">
        <img src="@/assets/img/v2/navbar/logo.png" class="logo-hrcloud" />
        <img src="@/assets/img/main/logo-payroll-tax.png" class="logo-payroll-tax" />
      </div>
      <div class="subscribe-content-container">
        <template v-if="!isSuccess">
          <div class="subscribe-content">
            <p>您确定要取消订阅吗？</p>
            <p>Are you sure to unsubscribe?</p>
          </div>
          <div class="subscribe-btn">
            <div class="subscribe-btn-item" @click="handleSubmit">
              <div>确定</div>
              <div>Confirm</div>
            </div>
            <div class="subscribe-btn-item" @click="handleCancel">
              <div>取消</div>
              <div>Cancel</div>
            </div>
          </div>
        </template>
        <div class="subscribe-content" v-else>
          <p>退订成功</p>
          <p>Unsubscribe successfully</p>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
  import * as api from '@/api/policy/policyLibrary';
  export default {
    name: "Subscribe",
    data() {
      return {
        bodyStyle: {
          padding: '40px',
          boxSizing: 'border-box',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-evenly'
        },
        isSuccess: false,
        loading: false
      }
    },
    methods: {
      handleSubmit() {
        this.loading = true;
        let params = {
          id: this.$route.query.req
        }
        api.expressCancel(params)
          .then(res => {
            this.loading = false;
            if (res.data.code == 0) {
              this.isSuccess = true;
            }
          })
          .catch(error => {
            this.loading = false;
          })
      },
      handleCancel() {
        window.close();
      }
    }
  }
</script>

<style lang="scss" scoped>
  .subscribe {
    font-size: 14px;
    height: 100%;
    .logo {
      font-size: 0;
      margin-bottom: 70px;
      .logo-hrcloud {
        height: 24px;
      }
      .logo-payroll-tax {
        height: 24px;
        margin-left: 20px;
      }
    }
    .subscribe-content-container {
      width: 300px;
      height: 100%;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      color: #333;
      font-weight: 650;
      .subscribe-content {
        line-height: 30px;
      }
      .subscribe-btn {
        display: flex;
        justify-content: space-evenly;
        .subscribe-btn-item {
          cursor: pointer;
          &:hover {
            color: #FF9601;
          }
        }
      }
    }
  }
</style>
